import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { selectPublishingMode } from 'core/store/selectors/selectPublishingMode'

export const useFocusOnKeyPress = () => {
  const isEditMode = useSelector(selectPublishingMode)

  const simulateTabByKeyPress = useCallback(() => {
    if (!isEditMode) {
      return
    }

    const floatingInputs = document.querySelectorAll<HTMLInputElement>(
      '.floating-number-input input'
    )

    const inputs = Array.from(floatingInputs)
      .filter((input) => !input.disabled)
      .filter((input) => !input.hidden)

    if (!inputs.length) {
      return
    }

    const currentIndex = inputs.findIndex((el) => el === document.activeElement)
    if (currentIndex === -1) {
      // If no element is focused or the focused element isn't in our list, focus the first one
      inputs[0].focus()
      return
    }

    inputs[currentIndex].blur()
    const nextIndex = (currentIndex + 1) % inputs.length
    inputs[nextIndex].focus()
  }, [isEditMode])

  return simulateTabByKeyPress
}
